// Accent- and case-insensitive comparison key, so "jose" finds "José".
export function fold(value: string): string {
  return value
    .normalize('NFD')
    .replace(/\p{Mn}/gu, '')
    .toLowerCase()
}
